export default "__VITE_ASSET__X0J0VmbE9Y6eehvFaNyYWw__"